<template>
	<v-container fluid class="height-100 trade">
		<v-card class="height-100" elevation="0">
			<v-card-title class="pl-4">
				<v-icon class="mr-2" color="blue">mdi-order-bool-ascending-variant</v-icon>
				工单管理
				<v-spacer />
				<v-text-field v-model="queryParam.condition" @change="searchQuery" @click:append="searchQuery" style="max-width: 380px" placeholder="请输入工单号查询" dense outlined clearable hide-details append-icon="mdi-feature-search-outline"></v-text-field
			></v-card-title>
			<v-card-text>
				<v-banner class="px-2 py-2 blue--text rounded" icon-color="blue" height="42" :color="$vuetify.theme.dark ? 'grey darken-3' : 'blue lighten-5'" tile single-line rounded outlined>
					<v-icon color="blue" style="vertical-align: sub">mdi-alert-circle-outline</v-icon>
					显示公司所有工单信息
				</v-banner>
				<v-data-table :headers="headers" :items="desserts" :loading="loading" disable-pagination loading-text="数据加载中..." class="elevation-0 vtk-cursor-pointer" hide-default-footer>
					<template v-slot:[`item.first_col`]="{ item }">
						<span>{{ desserts.indexOf(item) + 1 }}</span>
					</template>
					<template v-slot:[`item.objsName`]="{ item }">
						<v-list-item class="pl-0">
							<v-list-item-content>
								<v-list-item-title class="pb-1">
									{{ item.projName }}
								</v-list-item-title>
								<v-list-item-subtitle class="mb-1 pt-1">
									{{ item.objsName }} <span class="ml-2">{{ item.objsCode | idcard }}</span>
								</v-list-item-subtitle>
								<v-list-item-subtitle class="pt-1">
									<v-chip color="#19ff000f" style="color: #34c024" label small>
										服务时间：{{ item.servCtime | date("yyyy/MM/dd HH:mm:ss") }} ~
										<span v-if="item.servState == 1">{{ item.servFtime | date("yyyy/MM/dd HH:mm:ss") }} </span>
									</v-chip>
								</v-list-item-subtitle>
							</v-list-item-content>
						</v-list-item>
					</template>

					<template v-slot:[`item.servState`]="{ item }">
						<v-chip :color="item.servState | dict('0:#ffb90018/1:#2abc3120')" :class="item.servState | dict('0:orange--text/1:success--text')" label small>
							{{ item.servState | dict("0:服务中/1:已服务") }}
						</v-chip>
					</template>

					<template v-slot:[`item.rateState`]="{ item }">
						<v-chip :color="item.rateState | dict('0:#ffb90018/1:#2abc3120')" :class="item.rateState | dict('0:orange--text/1:success--text')" label small>
							{{ item.rateState | dict("0:未评价/1:已评价") }}
						</v-chip>
					</template>

					<template v-slot:[`item.rateStar`]="{ item }">
						<v-rating v-model="item.rateStar" background-color="grey lighten-2" color="warning" half-increments length="5" readonly size="20" dense></v-rating>
					</template>

					<template v-slot:[`item.actions`]="{ item }">
						<span @click="edit(item)" class="pointer blue--text mr-3">受理</span>
						<span @click="del(item)" class="pointer green--text mr-3">实施</span>
					</template>

					<template v-slot:no-data>
						<v-card class="px-6 pt-4 pb-4 mt-3" elevation="0" id="train">
							<p class="grey--text mt-4">暂无数据</p>
						</v-card>
					</template>
				</v-data-table>
				<v-divider />
				<pagination :page-sizes="[10, 20]" :page-data="pageData" @pageChange="getListPage" />
			</v-card-text>
		</v-card>
	</v-container>
</template>

<script>
import Storage from "@/commons/storage";
import Mixins from "@/compositions/mixins/minxs";
import pagination from "@/components/pagination";
import Message from "@/components/message";
export default {
	name: "DashTrade",
	mixins: [Mixins],
	components: { pagination },
	data() {
		return {
			tab: null,
			desserts: [],
			url: {
				list: "/view/urcds/page",
			},
			headers: [
				{ text: "序号", value: "first_col", sortable: false, width: 60 },
				{ text: "信息", value: "objsName", sortable: false },
				{ text: "服务状态", value: "servState", sortable: false, width: 100 },
				{ text: "评价状态", value: "rateState", sortable: false, width: 100 },
				{ text: "评价星级", value: "rateStar", sortable: false, width: 180 },
				// { text: "操作", value: "actions", sortable: false, width: 130 },
			],
			rateStar: 4,
		};
	},
	mounted() {
		this.queryParam.uniCode = Storage.get("_wit_acis_users").uniCode;
		this.loadPage();
	},
	methods: {
		toView() {
			Message.toast("当前应用开发中，尽请期待...", { color: "error" });
		},
	},
};
</script>

<style lang="scss" scoped>
::v-deep td:nth-child(2) .v-chip.v-chip--label {
	padding-left: 8px;
	padding-right: 8px;
	font-size: 10px;
	height: 20px;
	margin-right: 6px;
	// background: #e0e0e05e;
}
.border-dashed {
	border: 1px #2196f3 dashed;
}
.border-solid {
	border: 1px rgba(182, 182, 182, 0.6) solid;
}
::v-deep .v-banner--single-line .v-banner__wrapper {
	padding: 0 !important;
}
</style>
